import React from "react";

/* ── Image imports (replace filenames with your actual files) ── */
import HeroBgImg        from "../../asset/images/products/hero-bg.webp";
import BcSepIcon        from "../../asset/images/about/breadcrumb-separator.svg";

/* Product card images — Our Products */
import PreciconRImg     from "../../asset/images/products/precicon-r.webp";
import PreciconR3Img    from "../../asset/images/products/precicon-r3.webp";
import IGBTImg          from "../../asset/images/products/igbt-module.webp";
import AdorCoronaImg    from "../../asset/images/products/ador-corona-tr.webp";

/* ESP Power Supplies */
import Phase1Img        from "../../asset/images/products/1-phase.webp";
import Phase3Img        from "../../asset/images/products/3-phase.webp";
import EspControlsImg   from "../../asset/images/products/esp-controls.webp";

/* HFPS */
import VedikaImg        from "../../asset/images/products/vedika-7khz.webp";
import Vedika2Img       from "../../asset/images/products/vedika-2-20khz.webp";

/* ESP Management System */
import EpmsImg          from "../../asset/images/products/epms.webp";

/* Value Added Services */
import EspRMImg         from "../../asset/images/products/esp-rm.webp";
import NischintImg      from "../../asset/images/products/nischint-care.webp";
import RetrofitsImg     from "../../asset/images/products/retrofits.webp";
import ServiceRepairImg from "../../asset/images/products/service-repair.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .pr { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══════════════════════════════════════════
     1. HERO
  ══════════════════════════════════════════ */
  .pr-hero {
    position: relative;
    width: 100%;
    height: 460px;
    overflow: hidden;
  }

  .pr-hero-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }

  .pr-hero-overlay {
    position: absolute;
    inset: 0;
  }

  .pr-hero-content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 102px 48px 102px;
    max-width: 1600px;
    margin: 0 auto;
    left: 0; right: 0;
  }

  .pr-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px;
    font-weight: 600;
    color: #ffffff;
    line-height: 120%;
    margin-bottom: 15px;
  }

  .pr-hero-divider {
    width: 193px;
    height: 2px;
    background: #EB2019;
    margin-bottom: 15px;
    border: none;
  }

  /* ══════════════════════════════════════════
     2. BREADCRUMB
  ══════════════════════════════════════════ */
  .pr-breadcrumb {
    width: 100%;
    padding: 40px 0px 0px 0px;
  }

  .pr-breadcrumb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: center;
    gap: 0;
    flex-wrap: wrap;
  }

  .pr-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 14px;
    transition: color 0.15s;
  }

  .pr-bc-item:hover { color: #EB2019; }

  .pr-bc-sep {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: 0 8px;
    flex-shrink: 0;
  }

  .pr-bc-sep svg { display: block; }

  .pr-bc-item.active {
    color: #202020;
    font-weight: 500;
  }

  /* ══════════════════════════════════════════
     SHARED INNER
  ══════════════════════════════════════════ */
  .pr-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }

  /* ══════════════════════════════════════════
     SECTION DIVIDER
  ══════════════════════════════════════════ */
  .pr-divider {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }

  .pr-divider hr {
    border: none;
    border-top: 1px solid #EB2019;
    opacity: 0.3;
  }

  /* ══════════════════════════════════════════
     3. OUR PRODUCTS — title + 4 cards
  ══════════════════════════════════════════ */
  .pr-section-products {
    padding: 80px 0 80px 0;
  }

  .pr-section-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px;
    font-weight: 600;
    color: #202020;
    margin-bottom: 60px;
  }

  .pr-cards-4 {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 30px;
  }

  .pr-cards-3 {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
  }

  /* ── Card ── */
  .pr-card {
    background: #fff;
    border: none;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.10);
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .pr-card-img-wrap {
    width: 100%;
    height: 322px;
    overflow: hidden;
    background: #E8E8E8;
  }

  .pr-card-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .pr-card-img-placeholder {
    width: 100%;
    height: 100%;
    background: #E0E0E0;
    display: block;
  }

  .pr-card-body {
    padding: 24px;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .pr-card-title {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 600;
    color: #202020;
    margin-bottom: 14px;
    line-height: 140%;
  }

  .pr-card-desc {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 140%;
    flex: 1;
    margin-bottom: 14px;
  }

  .pr-learn-more {
    display: inline-flex;
    align-items: center;
    gap: 14px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #EB2019;
    text-decoration: none;
    transition: gap 0.2s;
  }
  .pr-learn-more1 {
    display: inline-flex;
    align-items: center;
    gap: 14px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #EB2019;
    text-decoration: none;
    transition: gap 0.2s;
    padding: 10px 20px;
    border: 1px solid #A7A7A7;
    border-radius: 10px;
  }

  .pr-learn-more:hover { gap: 10px; }

  .pr-learn-more svg {
    flex-shrink: 0;
  }

  /* ══════════════════════════════════════════
     SECTION BADGE (red pill) — CHANGE 1: now an <a> link
  ══════════════════════════════════════════ */
  .pr-section-wrap {
    padding: 80px 0;
  }

  .pr-badge {
    display: inline-block;
    background: #EB2019;
    color: #fff;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    padding: 14px 36px;
    border-radius: 10px;
    margin-bottom: 40px;
    text-decoration: none;
    transition: background 0.2s;
  }
  .pr-badge:hover { background: #c9181d; }

  /* ══════════════════════════════════════════
     ADOR PULSAR card — CHANGE 2: matches screenshot
  ══════════════════════════════════════════ */
  .pr-pulsar-card {
    background: #fff;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.10);
    border-radius: 10px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 40px 24px;
  }
  .pr-pulsar-label {
    font-family: 'Poppins', sans-serif;
    font-size: 24px;
    font-weight: 600;
    color: #EB2019;
    margin-bottom: 4px;
     text-align:center;
  }
  .pr-pulsar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px;
    font-weight: 600;
    color: #202020;
    margin-bottom: 32px;
    line-height: 100%;
    text-align:center;
  }
  .pr-pulsar-divider {
    width: 100%;
    height: 1px;
    background: #000000;
    
    border: none;
    max-width:241px;
    margin: 0 auto;
  }
  .pr-pulsar-coming {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
    text-align:center;
    margin-top: 24px;
  }

  /* ══════════════════════════════════════════
     ESP MANAGEMENT SYSTEM — split layout
  ══════════════════════════════════════════ */
  .pr-epms-grid {
    display: flex;
    gap: 0px;
    align-items: center;
    background: #F5F5F5;
    border-radius: 12px;
    overflow: hidden;
  }

  .pr-epms-text {
    flex: 0 0 698px;
    padding: 0px 134px 0px 44px;
  }

  .pr-epms-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px;
    font-weight: 600;
    color: #202020;
    margin-bottom: 14px;
    line-height: 140%;
  }

  .pr-epms-desc {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 1.7;
    margin-bottom: 24px;
  }

  .pr-epms-img-wrap {
    flex: 1;
    height: 400px;
    overflow: hidden;
  }

  .pr-epms-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  /* ══════════════════════════════════════════
     EMISSION REDUCTION — coming soon card
  ══════════════════════════════════════════ */
  .pr-coming-soon-card {
    background: #F9FAFA;
    border-radius: 12px;
    padding: 44px;
  }

  .pr-coming-soon-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px;
    font-weight: 600;
    color: #202020;
    margin-bottom: 14px;
  }

  .pr-coming-soon-text {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
  }

  .pr-card-coming {
    background: #fff;
    border: 1px solid #E8E8E8;
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .pr-card-coming .pr-card-img-placeholder {
    height: 210px;
  }

  .pr-card-coming .pr-card-body {
    padding: 20px 20px 24px 20px;
  }

  .pr-section-wrap:last-child {
    padding: 80px 0 120px 0;
  }
    .pr-cards-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
}

  /* ══════════════════════════════════════════
     RESPONSIVE — TABLET (max-width: 768px)
  ══════════════════════════════════════════ */
  @media (max-width: 768px) {
    .pr-hero             { height: 300px; }
    .pr-hero-content     { padding: 0 32px 36px 32px; justify-content: center; }
    .pr-hero-title       { font-size: 30px; }
    .pr-hero-divider     { width: 100%; max-width: 390px; }
    .pr-cards-2 { grid-template-columns: repeat(2, 1fr); gap: 24px; }
    .pr-breadcrumb       { padding: 28px 0 0 0; }
    .pr-breadcrumb-inner { padding: 0 32px; }
    .pr-inner            { padding: 0 32px; }
    .pr-divider          { padding: 0 32px; }

    .pr-section-products { padding: 40px 0 40px 0; }
    .pr-section-title    { font-size: 22px; margin-bottom: 24px; }

    .pr-card-img-wrap { height: 220px; }
    .pr-cards-4          { grid-template-columns: repeat(2, 1fr); gap: 24px; }
    .pr-card-body        { padding: 20px; }
    .pr-card-title       { font-size: 18px; margin-bottom: 10px; }
    .pr-card-desc        { font-size: 14px; margin-bottom: 10px; }
    .pr-badge            { font-size: 14px; padding: 12px 30px; margin-bottom: 24px; }
    .pr-cards-3          { grid-template-columns: repeat(2, 1fr); gap: 24px; }

    .pr-section-wrap     { padding: 40px 0; }
    .pr-epms-img-wrap    { flex: none; width: 100%; height: 300px; }
    .pr-epms-grid        { flex-direction: column-reverse; gap: 0; }
    .pr-epms-text        { flex: none; width: 100%; padding: 32px 32px 24px 32px; }
    .pr-epms-title       { font-size: 22px; margin-bottom: 12px; }
    .pr-epms-desc        { font-size: 14px; margin-bottom: 12px; }
    .pr-learn-more1      { font-size: 14px; }
    .pr-coming-soon-card { padding: 32px; }
    .pr-coming-soon-title { font-size: 22px; margin-bottom: 12px; }
    .pr-coming-soon-text { font-size: 14px; }
    .pr-section-wrap:last-child { padding: 40px 0 40px 0; }
    .pr-pulsar-card      { padding: 30px 20px; }
    .pr-pulsar-title     { font-size: 26px; margin-bottom: 24px;}
    .pr-pulsar-coming { margin-top: 14px;}
    .pr-pulsar-divider {max-width: 200px;}
    
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — MOBILE (max-width: 480px)
  ══════════════════════════════════════════ */
  @media (max-width: 480px) {
    .pr-hero             { height: 400px; }
    .pr-hero-bg          { object-fit: cover; object-position: center; display: block; }
    .pr-hero-content     { padding: 16px; justify-content: center; }
    .pr-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .pr-hero-divider     { width: 100%; max-width: 240px; margin-bottom: 12px; }
    .pr-cards-2 { grid-template-columns: 1fr; gap: 30px; }
    .pr-breadcrumb       { padding: 30px 0 0 0; }
    .pr-breadcrumb-inner { padding: 0 16px; gap: 8px; }
    .pr-bc-item          { font-size: 13px; gap: 14px; }
    .pr-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .pr-inner            { padding: 0 16px; }
    .pr-divider          { padding: 0 16px; }

    .pr-section-products { padding: 60px 0 60px 0; }
    .pr-section-title    { font-size: 20px; margin-bottom: 30px; }
    .pr-cards-4          { grid-template-columns: 1fr; gap: 30px; }
    .pr-cards-3          { grid-template-columns: 1fr; gap: 30px; }

    .pr-card-img-wrap    { height: 298px; }
    .pr-card-body        { padding: 22px; }
    .pr-card-title       { font-size: 20px; margin-bottom: 15px; }
    .pr-card-desc        { margin-bottom: 15px; }
    .pr-badge            { font-size: 14px; padding: 12px 36px; margin-bottom: 30px; }
    .pr-section-wrap     { padding: 60px 0; }

    .pr-epms-text        { padding: 24px 20px 30px 20px; }
    .pr-epms-title       { font-size: 20px; }
    .pr-epms-desc        { margin-bottom: 24px; }
    .pr-epms-img-wrap    { height: 212px; }

    .pr-coming-soon-card { padding: 28px 44px; }
    .pr-coming-soon-title { font-size: 20px; margin-bottom: 14px; }
    .pr-section-wrap:last-child { padding: 60px 0 60px 0; }
    .pr-pulsar-card      { padding: 189px 16px; }
    .pr-pulsar-title     { font-size: 24px;      margin-bottom: 16px;}
    .pr-pulsar-label { font-size: 18px; }
    .pr-pulsar-coming { margin-top: 10px;}
  }
`;

/* Arrow icon for Learn More */
const ArrowRight = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M3 8h10M9 4l4 4-4 4" stroke="#EB2019" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

/* Reusable product card */
const ProductCard = ({ img, imgAlt = "", title, desc, href = "#", comingSoon = false }) => (
  <div className="pr-card">
    <div className="pr-card-img-wrap">
      {img
        ? <img className="pr-card-img" src={img} alt={imgAlt || title} />
        : <div className="pr-card-img-placeholder" />
      }
    </div>
    <div className="pr-card-body">
      <h3 className="pr-card-title">{title}</h3>
      {comingSoon
        ? <p className="pr-card-desc">Coming Soon...</p>
        : <p className="pr-card-desc">{desc}</p>
      }
      {!comingSoon && (
        <a href={href} className="pr-learn-more">
          Learn More <ArrowRight />
        </a>
      )}
    </div>
  </div>
);

export default function ProductsPage() {
  return (
    <div className="pr">
      <style>{CSS}</style>

      {/* ══ 1. HERO ══ */}
      <section className="pr-hero">
        <img className="pr-hero-bg" src={HeroBgImg} alt="Products Hero" />
        <div className="pr-hero-overlay" />
        <div className="pr-hero-content">
          <h1 className="pr-hero-title">Products</h1>
          <hr className="pr-hero-divider" />
        </div>
      </section>

      {/* ══ 2. BREADCRUMB ══ */}
      <nav className="pr-breadcrumb" aria-label="Breadcrumb">
        <div className="pr-breadcrumb-inner">
          <a href="/" className="pr-bc-item">Home</a>
          <span className="pr-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="#" className="pr-bc-item">Business</a>
          <span className="pr-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="pr-bc-item active">Clean Air</span>
        </div>
      </nav>

      {/* ══ 3. OUR PRODUCTS ══ */}
      <section className="pr-section-products">
        <div className="pr-inner">
          <h2 className="pr-section-title">Our Products</h2>
          <div className="pr-cards-4">
            <ProductCard
              img={PreciconRImg}
              title="Precicon R"
              desc="Ador Powertron's Precicon R is a thyristor-based ESP power controller designed ..."
              href="/products/precicon-r"
            />
            <ProductCard
              img={PreciconR3Img}
              title="Precicon R3"
              desc="Ador Powertron's Precicon R3 is a next-generation thyristor-based power controller..."
              href="/products/precicon-r3"
            />
            <ProductCard
              img={IGBTImg}
              title="IGBT Module"
              desc="Ador Powertron's Precicon S is an advanced IGBT-based power controller ..."
              href="/products/precicon-s"
            />
            <ProductCard
              img={AdorCoronaImg}
              title="Ador Corona TR Set"
              desc="Ador TR Sets are available in both 1-phase, 3-phase and 400 Hz configurations, ..."
              href="/products/ador-tr-set"
            />
          </div>
        </div>
      </section>

      {/* ══ DIVIDER ══ */}
      <div className="pr-divider"><hr /></div>

      {/* ══ 4. ESP POWER SUPPLIES ══ */}
      <section className="pr-section-wrap">
        <div className="pr-inner">
          {/* CHANGE 1: badge is now a clickable link */}
          <a href="/products/esp-power-supplies" className="pr-badge">ESP Power Supplies</a>
          <div className="pr-cards-3">
            <ProductCard
              img={Phase1Img}
              title="1 Phase Solutions"
              desc="The ESP power supplies were introduced in 1970s & ever since have a good field-proven performance..."
              href="/products/esp-power-supplies/1-phase-solutions"
            />
            <ProductCard
              img={Phase3Img}
              title="3 Phase Solutions"
              desc="They consist primarily of a Thyristor controlled power-circuit, wherein the firing of the Thyristor is controlled to provide..."
              href="/products/esp-power-supplies/3-phase-solutions"
            />
            <ProductCard
              img={EspControlsImg}
              title="ESP Controls"
              desc="Our Third generation micro-controller based PRECICON-R Controller is not only a T/R controller, but also an ESP controller."
              href="/products/esp-power-supplies/esp-controls"
            />
          </div>
        </div>
      </section>

      {/* ══ DIVIDER ══ */}
      <div className="pr-divider"><hr /></div>

      {/* ══ 5. HFPS ══ */}
      {/* <section className="pr-section-wrap">
        <div className="pr-inner">
          
          <a href="/products/hfps" className="pr-badge">HFPS</a>
          <div className="pr-cards-3">
           
            <div className="pr-pulsar-card">
              <p className="pr-pulsar-label">ADOR</p>
              <h3 className="pr-pulsar-title">Pulsar</h3>
              <hr className="pr-pulsar-divider" />
              <p className="pr-pulsar-coming">Coming Soon</p>
            </div>

            <ProductCard
              img={VedikaImg}
              title="Vedika 7.0kHz"
              desc="Ador has a robust solution which is not a project and doesn't need any mechanical or process shut down for enhancing performance of ESP...."
              href="/products/hfps/vedika-7-0khz/"
            />
            <ProductCard
              img={Vedika2Img}
              title="Vedika 2.0 > 20 kHz"
              desc="The 5th generation High frequency power supply of ESP– constant- high- frequency electrostatic power source, is the only one company..."
              href="/products/hfps/vedika-20-0khz/"
            />
          </div>
        </div>
      </section> */}
      {/* ══ 5. HFPS ══ */}
<section className="pr-section-wrap">
  <div className="pr-inner">
    <a href="/products/hfps" className="pr-badge">HFPS</a>
    <div className="pr-cards-2">
      <ProductCard
        img={VedikaImg}
        title="Vedika 7.0kHz"
        desc="Ador has a robust solution which is not a project and doesn't need any mechanical or process shut down for enhancing performance of ESP...."
        href="/products/hfps/vedika-7-0khz/"
      />
      <ProductCard
        img={Vedika2Img}
        title="Vedika 2.0 > 20 kHz"
        desc="The 5th generation High frequency power supply of ESP– constant- high- frequency electrostatic power source, is the only one company..."
        href="/products/hfps/vedika-20-0khz/"
      />
    </div>
  </div>
</section>

      {/* ══ DIVIDER ══ */}
      <div className="pr-divider"><hr /></div>

      {/* ══ 6. ESP MANAGEMENT SYSTEM ══ */}
      <section className="pr-section-wrap">
        <div className="pr-inner">
          {/* CHANGE 1: badge is now a clickable link */}
          <a href="/products/esp-management-system" className="pr-badge">ESP Management System</a>
          <div className="pr-epms-grid">
            <div className="pr-epms-text">
              <h3 className="pr-epms-title">ESP Management System</h3>
              <p className="pr-epms-desc">
                EPMS (EPMS – Data Management System) will be loaded on a PC. The EPMS operates on a Windows platform & uses well known Windows icons & buttons. This makes it easy for the users to operate the EPMS.
              </p>
              <a href="/products/esp-management-system" className="pr-learn-more1">
                Learn More <ArrowRight />
              </a>
            </div>
            <div className="pr-epms-img-wrap">
              <img className="pr-epms-img" src={EpmsImg} alt="ESP Management System" />
            </div>
          </div>
        </div>
      </section>

      {/* ══ DIVIDER ══ */}
      <div className="pr-divider"><hr /></div>

      {/* ══ 7. EMISSION REDUCTION SOLUTIONS ══ */}
      <section className="pr-section-wrap">
        <div className="pr-inner">
          {/* CHANGE 1: badge is now a clickable link */}
          <a href="" className="pr-badge">Emission Reduction Solutions</a>
          <div className="pr-coming-soon-card">
            <h3 className="pr-coming-soon-title">Emission Reduction Solutions</h3>
            <p className="pr-coming-soon-text">Coming Soon</p>
          </div>
        </div>
      </section>

      {/* ══ DIVIDER ══ */}
      <div className="pr-divider"><hr /></div>

      {/* ══ 8. VALUE ADDED SERVICES ══ */}
      <section className="pr-section-wrap">
        <div className="pr-inner">
          {/* CHANGE 1: badge is now a clickable link */}
          <a href="/products/value-added-services" className="pr-badge">Value Added Services</a>
          <div className="pr-cards-4">
            <ProductCard
              img={EspRMImg}
              title="ESP R&amp;M"
              desc="Ador can provide electromechanical solution for mid life upgrade of ESP..."
              href="/products/value-added-services"
            />
            <ProductCard
              img={NischintImg}
              title="Nischint Care"
              desc=""
              href="/products/value-added-services"
            />
            <ProductCard
              img={RetrofitsImg}
              title="Retrofits"
              desc="Ador has retrofitted the controllers of nearly 500+ sites in India ..."
              href="/products/value-added-services"
            />
            <ProductCard
              img={ServiceRepairImg}
              title="Service &amp; Repair"
              desc="Get all the Help &amp; Support"
              href="/products/value-added-services"
            />
          </div>
        </div>
      </section>

    </div>
  );
}